import React, { useState } from 'react';
import { CheckRatingDialog } from './components';
import { useCheckRatingNotification } from './hooks';

const RatingNotificationDialog = () => {
  // Local state
  const [ratingDialogOpened, setRatingDialogOpened] = useState(false);

  const { data, checkNotification, loading } = useCheckRatingNotification((response) => {
    setRatingDialogOpened(response.show);
  });

  // Main render
  return (
    <CheckRatingDialog
      open={ratingDialogOpened}
      ratingNotification={data}
      disabled={loading}
      onCheckRating={checkNotification}
    />
  );
};

export default RatingNotificationDialog;
